import React, { useState, useEffect } from 'react'
import { Button, Modal, Form, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { connectAmiDevice, unlinkAmiDevice } from '../actions/participantActions'
import { CONNECT_AMI_DEVICE_RESET } from '../constants/participantConstants'

export const SmartWatchConnection = ({
  participantId,
  studyId,
  initialSubjectId = '',
  onConnectionChange,
}) => {
  const [show, setShow] = useState(false)
  const [subjectId, setSubjectId] = useState('')
  const [error, setError] = useState('')

  const dispatch = useDispatch()

  const connectAmiDeviceState = useSelector((state) => state.connectAmiDevice)
  const { loading, success, error: connectError } = connectAmiDeviceState

  const hasLinkedSubject = Boolean((initialSubjectId || '').trim())

  const handleOpen = () => {
    setShow(true)
    setSubjectId(initialSubjectId || '')
    setError('')
    dispatch({ type: CONNECT_AMI_DEVICE_RESET })
  }

  const handleClose = () => {
    if (loading) {
      return
    }
    setShow(false)
    setSubjectId('')
    setError('')
    dispatch({ type: CONNECT_AMI_DEVICE_RESET })
  }

  useEffect(() => {
    if (show) {
      setSubjectId(initialSubjectId || '')
    }
  }, [show, initialSubjectId])

  useEffect(() => {
    if (connectError) {
      setError(connectError)
    }
  }, [connectError])

  useEffect(() => {
    if (success) {
      onConnectionChange?.()
      handleClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success])

  const handleTestAndConnect = () => {
    const trimmed = subjectId.trim()
    if (!trimmed) {
      setError('AMI Device Subject ID is required')
      return
    }
    setError('')
    dispatch(connectAmiDevice(studyId, participantId, trimmed))
  }

  const handleUnlink = () => {
    if (
      !window.confirm(
        'Unlink the AMI Device Subject ID for this participant? The mobile app report will stop loading watch data until a new ID is connected.'
      )
    ) {
      return
    }
    setError('')
    dispatch(unlinkAmiDevice(studyId, participantId))
  }

  return (
    <>
      <Button variant='primary' className='btn-sm m-1' onClick={handleOpen}>
        Smart Watch Connection
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Smart Watch Connection Setup</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && (
            <Alert variant='danger' onClose={() => setError('')} dismissible>
              {error}
            </Alert>
          )}
          {hasLinkedSubject && (
            <Alert variant='info' className='mb-3'>
              Currently linked: <strong>{initialSubjectId}</strong>
            </Alert>
          )}
          <Form.Group controlId='amiDeviceSubjectId'>
            <Form.Label>AMI Device Subject ID</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter AMI Device Subject ID'
              value={subjectId}
              onChange={(e) => setSubjectId(e.target.value)}
              disabled={loading}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className='d-flex flex-wrap justify-content-between'>
          <div>
            {hasLinkedSubject && (
              <Button
                variant='outline-danger'
                onClick={handleUnlink}
                disabled={loading}
              >
                {loading ? 'Working…' : 'Unlink Subject ID'}
              </Button>
            )}
          </div>
          <div>
            <Button
              variant='secondary'
              onClick={handleClose}
              disabled={loading}
              className='me-2'
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={handleTestAndConnect}
              disabled={loading || !subjectId.trim()}
            >
              {loading ? 'Connecting…' : 'Test and Connect'}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SmartWatchConnection
